
import React from 'react';
import { Table } from 'react-bootstrap';
import TagInput from './tag_input';

const styles = {
  tag: {
    backgroundColor: '#eee',
    color: 'black',
    borderRadius: '10px',
    margin: '10px',
    padding: '10px',
    flexDirection: 'row',
    display: 'flex',
  },
  tagText: {
    flex: 1,
  },
  tagX: {
    backgroundColor: '#eee',
    color: 'black',
    width: '20px',
    borderRadius: '5px',
    border: '1px solid #777',
    textAlign: 'center',
    marginLeft: '10px',
    cursor: 'pointer',
  },
};

const UserTags = ({
  tags,
  addTag,
  removeTag,
}) =>  (
  <Table bordered style={{ marginLeft: '20px' }}>
    <tbody>
      <TagInput selectVal={addTag} />
      {
        tags.map(tag => (
          <div style={styles.tag}><div style={styles.tagText}>{`${tag}`}</div>
            <div style={styles.tagX} onClick={()=>{ removeTag(tag) }}>x</div>
          </div>
        ))
      }
    </tbody>
  </Table>
)


export default UserTags;